export default __webpack_public_path__ + "static/media/car-service.b886feab.png";